export default __webpack_public_path__ + "4cebbef5e7a57ffee7561d17c795ed67.png";